<script setup>

import SwitchInput from "@/Components/SwitchInput.vue";
import Input from "@/Components/Input.vue";
import DropdownLink from "@/Components/DropdownLink.vue";
import Dropdown from "@/Components/Dropdown.vue";
import Spinner from "@/Components/Icons/Spinner.vue";
import MaskIcon from "@/Components/MaskIcon.vue";
import {computed, onMounted, ref} from "vue";

const emits = defineEmits(['update:search', 'update:sellerOnline', 'update:offerSort'])

const sort = defineModel('sort')

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    sellerOnline: {
        type: Boolean,
        default: false
    },
    search: String | undefined,
    arrSort: Array
})

const screenWidth = ref(1024);
onMounted(() => {
    if (typeof window !== 'undefined') {
        screenWidth.value = window.innerWidth;
    }
});

const sortName = computed(() => {
    return props.arrSort.find(item => item.val === sort.value.val).title
})

</script>

<template>
    <div class="lg:bg-white dark:lg:bg-dark-blue rounded-lg lg:p-2.5 flex flex-col lg:flex-row items-center gap-2">
        <Input :border-focus="true"
               :model-value="search"
               @update:modelValue="emits('update:search', $event)" :placeholder="$t('Search offers')">
            <template #left-icon>
                <MaskIcon src="/assets/icons/search.svg" class="w-4 h-[17px] bg-[#131933] dark:bg-slate-400"/>
            </template>
            <template #right-icon>
                <div v-if="loading" class="flex">
                    <Spinner class="self-center mr-0"/>
                </div>
                <button v-else-if="search" @click="emits('update:search', '')">
                    <img src="/assets/icons/clear.svg" alt=""/>
                </button>

            </template>
        </Input>
        <div
            class="w-full flex justify-between lg:justify-end bg-white dark:bg-dark-blue lg:bg-transparent rounded-lg lg:rounded-0 py-2.5 px-2.5 lg:p-0 gap-3">
            <SwitchInput class="text-xs font-normal whitespace-nowrap"
                         :model-value="sellerOnline"
                         @update:modelValue="emits('update:sellerOnline', $event)"
                         :title="$t('sellers online only')"></SwitchInput>
            <Dropdown :align="screenWidth < 768 ? 'right' : 'left'"
                      width="auto">
                <template v-slot:trigger="{open}">

                <span class="flex rounded-md items-center">
                    <button type="button"
                            class="whitespace-nowrap dark:text-slate-200 inline-flex items-center text-sm font-medium leading-120 focus:outline-hidden transition ease-in-out">
                      {{ sortName }}
                        <MaskIcon src="/assets/icons/arrow.svg" class="w-6 h-6 transition-all duration-75 bg-[#21272A] dark:bg-white" :class="{'rotate-180': open}"/>
                    </button>

                </span>
                </template>
                <template #content>

                    <!-- Team Management -->

                    <template v-for="itemSort in arrSort">
                        <dropdown-link as="button" class="border-b border-dashed border-slate-300 dark:border-slate-700"
                                       @click="sort = itemSort"
                        >
                            {{ itemSort.title }}
                        </dropdown-link>
                    </template>

                </template>
            </Dropdown>
        </div>
    </div>
</template>

<style scoped>

</style>
